import { Button } from 'antd';
import React from 'react';

type PricingRulePopinProps = {
  title?: string;
  description: string;
  onClickNo: () => void;
  onClickYes: () => void;
  isUpdatingPricingRule?: boolean;
};

export const PricingRulePopin = ({
  title,
  description,
  onClickNo,
  onClickYes,
  isUpdatingPricingRule,
}: PricingRulePopinProps) => {
  return (
    <div className="automate-discount-confirmation-popin">
      <div className="popin-text">
        {title && <p className="bold-text">{title}</p>}
        <p>{description}</p>
      </div>
      <div className="popin-cta">
        <Button
          id="cancelDesactivationDiscountRule"
          className="popin-no"
          onClick={onClickNo}
        >
          No
        </Button>
        <Button
          id="validateDesactivationDiscountRule"
          className="popin-yes"
          type="primary"
          onClick={onClickYes}
          loading={isUpdatingPricingRule}
        >
          Yes
        </Button>
      </div>
    </div>
  );
};
